import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useEmployeePackages = ({ employeeId }) => {
  const { accountId } = useAccount();
  const storeKey = ['packages', accountId, employeeId];

  const { isLoading, data } = useQuery(storeKey, () =>
    api.fetchEmployeePackages({ accountId, employeeId }, { staleTime: 0 })
  );

  return {
    isLoading,
    data: data?.data || []
  };
};

export default useEmployeePackages;
